/* Pawesome Club — horizontale scroller met pijltjes en bolletjes */
(function () {
  function init(section) {
    var scroller = section.querySelector('.bl-paw-club__scroller');
    if (!scroller || scroller.dataset.blInit) return;
    scroller.dataset.blInit = '1';
    var dots = Array.prototype.slice.call(section.querySelectorAll('.bl-paw-club__dots button'));
    var count = scroller.children.length;
    var idx = 0;
    var timer;

    function step() {
      var first = scroller.children[0];
      if (!first) return 316;
      var gap = parseFloat(getComputedStyle(scroller).gap) || 16;
      return first.getBoundingClientRect().width + gap;
    }
    function paint() {
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    }
    function goTo(i) {
      idx = Math.max(0, Math.min(count - 1, i));
      var max = scroller.scrollWidth - scroller.clientWidth;
      scroller.scrollTo({ left: Math.min(idx * step(), max), behavior: 'smooth' });
      paint();
    }

    var prev = section.querySelector('.bl-paw-club__arrow--prev');
    var next = section.querySelector('.bl-paw-club__arrow--next');
    if (prev) prev.addEventListener('click', function () { goTo(idx - 1); });
    if (next) next.addEventListener('click', function () { goTo(idx + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

    scroller.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var max = scroller.scrollWidth - scroller.clientWidth;
        var i = max - scroller.scrollLeft < 8 ? count - 1 : Math.round(scroller.scrollLeft / step());
        idx = Math.max(0, Math.min(count - 1, i));
        paint();
      }, 80);
    }, { passive: true });

    paint();
  }

  function boot() {
    document.querySelectorAll('.bl-paw-club').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
